import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Detect language from URL
  const getLanguageFromPath = () => {
    const path = location.pathname;
    if (path.startsWith('/es')) return 'es';
    if (path.startsWith('/fr')) return 'fr';
    return 'en';
  };

  const [language, setLanguage] = useState(getLanguageFromPath());

  useEffect(() => {
    setLanguage(getLanguageFromPath());
  }, [location.pathname]);

  const changeLanguage = (newLang) => {
    const currentPath = location.pathname;
    let newPath = currentPath;
    
    // Remove current language prefix
    if (currentPath.startsWith('/es')) {
      newPath = currentPath.substring(3) || '/';
    } else if (currentPath.startsWith('/fr')) {
      newPath = currentPath.substring(3) || '/';
    }
    
    // Add new language prefix (except for English)
    if (newLang === 'es') {
      newPath = '/es' + newPath;
    } else if (newLang === 'fr') {
      newPath = '/fr' + newPath;
    }
    
    navigate(newPath);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
